
  import { Vue, Component, PropSync } from 'vue-property-decorator';
  import { AddressCardModel } from '@/models';
  
  @Component
  export default class SponsorSiteInfo extends Vue {
    @PropSync('site', { type: AddressCardModel }) syncSite!: AddressCardModel;
    @PropSync('sponsor', { type: AddressCardModel }) syncSponsor!: AddressCardModel;

    get showSponsor() {
      return this.syncSponsor !== null && this.syncSponsor.name !== '';
    }

    get showSite() {
      return this.syncSite !== null && this.syncSite.name !== '';
    }
  }
